import { render } from "./leavesdefinition-admin-model.vue?vue&type=template&id=5480f24c"
import script from "./leavesdefinition-admin-model.vue?vue&type=script&lang=js"
export * from "./leavesdefinition-admin-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__